import { GlobalOutlined } from "@ant-design/icons"
import { Flex, Select, type SelectProps, Typography } from "antd"
import React, { useMemo } from "react"

import { TIMEZONE_GROUPS } from "../../constants/timezones.ts"

const { Text } = Typography

// Popular repeats zones that also sit under their region; without a key of its
// own, rc-select's virtual list painted recycled rows onto the wrong label.
// Exported for TimezoneSelect.search.test.tsx.
export function buildTimezoneOptions() {
  return TIMEZONE_GROUPS?.map((group) => ({
    label: <Text type="secondary">{group?.label}</Text>,
    title: group?.label,
    options: group?.options?.map((option) => ({
      key: `${group?.label}-${option.value}`,
      value: option.value,
      label: (
        <Flex justify="space-between">
          <Text>{option?.label}</Text>
          <Text type="secondary">
            {option?.offset} {option?.abbr ? `(${option?.abbr})` : ""}
          </Text>
        </Flex>
      ),
      searchText: option?.label?.toLowerCase()
    }))
  }))
}

export function TimezoneSelect(props: SelectProps) {
  const options = useMemo(() => buildTimezoneOptions(), [])

  return (
    <Select
      showSearch
      optionFilterProp="searchText"
      placeholder="Select timezone"
      suffixIcon={<GlobalOutlined />}
      notFoundContent="No timezone found"
      options={options}
      {...props}
    />
  )
}
